// extracted by mini-css-extract-plugin
export default {"sortable":"AdminPanelPageHeaders_sortable__6Plco","asc":"AdminPanelPageHeaders_asc__J2YHO","desc":"AdminPanelPageHeaders_desc__M6y4C"};